export default [
  {
    path: "/layout-xml",
    name: "XML",
    component: () => import("../views/LayoutXml"),
    meta: { requiresAuth: true },
  },
];
